import { Router, RouterModule } from '@angular/router';
import { GlobalServiceService } from './../../shared/services/global-service.service';
import { HomeService } from './../../shared/services/home.service';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'dc-global-footer',
    templateUrl: './global-footer.component.html',
    styleUrls: ['./global-footer.component.css'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})

export class GlobalFooterComponent implements OnInit {

  social_links = [];
  is_front_logged;
  showLink1;
  showLink2;
  showLink3;
  showLink4;
  showLink5;
  CurrentDate;
  logged_user_email;
  hideFooter = 0;

  constructor(private home: HomeService, private global : GlobalServiceService, private router: Router) { }

  ngOnInit() {
      // this.socialLinks('8,9,10,11,12');
      this.global.logged_user_email.subscribe(res =>{
        this.logged_user_email = res;
      })

      this.global.hideFooterOnly.subscribe(res => {
        if (res === 1) this.hideFooter = 1;
        else this.hideFooter = 0;
      });
  }

  socialLinks(link_id) {
    // this.home.homeSocial(link_id).subscribe(res =>{
    //   console.log(res);
    // })
  }

  //method showHideLinks
  showHideLinks(id){
    if(id==2){
        this.showLink2 = !this.showLink2;
        this.showLink1 = false;
    }
    if(id==1){
        this.showLink1 = !this.showLink1;
        this.showLink2 = false;
    }
    /********************** New Rahul***************************/
    if(id==3){
        this.showLink3 = !this.showLink3;
        this.showLink4 = false;
        this.showLink5 = false;
    }
    if(id==4){
        this.showLink4 = !this.showLink4;
        this.showLink3 = false;
        this.showLink5 = false;
    }
    if(id==5){
        this.showLink5 = !this.showLink5;
        this.showLink3 = false;
        this.showLink4 = false;
    }
      /********************** New Rahul***************************/
  }

  redirectTo(path) {
    this.router.navigate([path]);
    this.global._scrollToTop();
  }

}
